(() => {
    /**
     *
     * @param {string} selector
     * @returns {Promise<HTMLDivElement>}
     */
    function waitForElm(selector) {
        console.log('waiting for elem ' + selector);
        return new Promise((resolve) => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver((mutations) => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });
        });
    }


    waitForElm('.t4s-drawer__bottom button[name="checkout"]').then((el) => {
        setTimeout(() => {
            console.log('binding cleever checkout click');
            el.addEventListener('click', window.cleeverCheckouthandleClick);
        }, 100);
    });

    waitForElm('.t4s-cart__threshold').then((container) => {

        const handleThreshold = () => {
             const complete = !container.textContent.toLowerCase().includes('spend');
            /**
             * @type {HTMLSpanElement}
             */
            const notEligibleElementText = document.querySelector(
                'cleever-not-eligible-discount span'
            );
            console.log({ complete });
            notEligibleElementText.hidden = complete;
        }
        handleThreshold()
        const observer = new MutationObserver((mutations) => {
           handleThreshold()
        });

        observer.observe(container, {
            childList: true,
            subtree: true,
        });
    })
})();
